import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { ITimeInputProps, TimeInput } from '../TimeInput';

//FYI: this simplifies integration with Formik. See README

interface ITimeField extends Partial<ITimeInputProps> {
  name: string;
  allowInvalidValues?: boolean;
}

export const TimeField: React.FC<ITimeField> = ({ name, allowInvalidValues, ...rest }) => {
  const formik = useFormikContext();
  const onChange = (value: any) => {
    formik.setFieldTouched(name as never);
    formik.setFieldValue(name as never, value);
    if (rest.onChange) {
      rest.onChange(value);
    }
  };
  const value = getIn(formik.values, name);
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;
  return (
    <TimeInput
      {...rest}
      value={value}
      onChange={onChange}
      errorText={errorText}
      allowInvalidValues={allowInvalidValues}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
